import { useSettings } from "../contexts/SettingsContext";

export default function OpenBadge({ className = "" }) {
  const { status } = useSettings();
  if (!status) return null;
  const isPause = !status.open && status.label.toLowerCase().includes("pause");
  const color = status.open ? "bg-emerald-500" : isPause ? "bg-amber-500" : "bg-red-500";
  return (
    <span
      data-testid="open-status-badge"
      className={`inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 shadow-sm ${className}`}
    >
      <span className={`relative flex h-2 w-2`}>
        <span className={`absolute inline-flex h-full w-full animate-ping rounded-full opacity-60 ${color}`}></span>
        <span className={`relative inline-flex h-2 w-2 rounded-full ${color}`}></span>
      </span>
      {status.label}
    </span>
  );
}
